/* ezu: 選んだ色の写真だけをギャラリーに表示する
   使い方: 画像のaltテキストの末尾に「#ブラウン」のように、色オプションの値を
   ハッシュタグで書く。その色が選ばれているときだけ、その画像が表示される。
   ハッシュタグのない画像（共通カット）は、どの色でも表示される。
   「#カバー」を付けた画像（全色を並べた表紙カット）は、ページを開いた時点では
   先頭に表示され、お客さまが色を選び直した瞬間から非表示になる。
   altにハッシュタグを使っていない商品では、何も起こらない。 */
(function () {
  'use strict';
  if (window.ezuVariantMediaFilter) return;
  window.ezuVariantMediaFilter = true;

  var TAG_RE = /#[^\s#"']+/g;
  var COVER_TAG = 'カバー';
  /* URLに ?variant= が付いている＝色を指定して来ている、とみなす */
  var userPicked = /[?&]variant=/.test(window.location.search);

  function tagsOfItem(li) {
    var img = li.querySelector('img');
    var alt = (img && img.getAttribute('alt')) || '';
    var m = alt.match(TAG_RE) || [];
    return m.map(function (t) { return t.slice(1); });
  }

  function currentOptions() {
    var picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return [];
    var values = [];
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
      values.push(i.value);
    });
    picker.querySelectorAll('select').forEach(function (s) {
      if (s.value) values.push(s.value);
    });
    return values;
  }

  function applyFilter(gallery, options) {
    var items = gallery.querySelectorAll('.product__media-item, .thumbnail-list__item');
    if (!items.length) return;

    var allTags = {};
    items.forEach(function (li) {
      tagsOfItem(li).forEach(function (t) { if (t !== COVER_TAG) allTags[t] = true; });
    });
    if (!Object.keys(allTags).length) return;

    var selected = options.filter(function (o) { return allTags[o]; });
    if (!selected.length) return;

    /* 表紙カットは、色を選び直すまでは先頭に置く
       （テーマは選択中バリアントの画像を先頭に並べ替えるため） */
    if (!userPicked) {
      items.forEach(function (li) {
        var parent = li.parentNode;
        if (tagsOfItem(li).indexOf(COVER_TAG) !== -1 && parent && parent.firstElementChild !== li) {
          parent.insertBefore(li, parent.firstElementChild);
        }
      });
    }

    var visibleSlides = 0;
    items.forEach(function (li) {
      var tags = tagsOfItem(li);
      var isCover = tags.indexOf(COVER_TAG) !== -1;
      var colorTags = tags.filter(function (t) { return t !== COVER_TAG; });
      var show;
      if (isCover) {
        show = !userPicked;
      } else {
        show = !colorTags.length || colorTags.some(function (t) { return selected.indexOf(t) !== -1; });
      }
      li.style.display = show ? '' : 'none';
      if (show && li.classList.contains('product__media-item')) visibleSlides++;
    });

    gallery.querySelectorAll('slider-component').forEach(function (s) {
      if (typeof s.initPages === 'function') s.initPages();
    });
    var total = gallery.querySelector('.slider-counter--total');
    if (total && visibleSlides > 0) total.textContent = visibleSlides;
  }

  function refresh() {
    var options = currentOptions();
    if (!options.length) return;
    document.querySelectorAll('media-gallery').forEach(function (g) {
      applyFilter(g, options);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects')) {
      userPicked = true;
      setTimeout(refresh, 0);
    }
  });
})();
